import { render } from "./NoteLoginId.vue?vue&type=template&id=d63d4c34"
const script = {}

import exportComponent from "/home/ubuntu/kokoroduke-admin/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__